import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateCartQuantity, removeFromCart } from 'store/cart/action';
import { currency } from 'config/env';

function Index({ isOpen, setIsOpen }) {
  const { items } = useSelector(state => state.cart || { items: [] });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleUpdate = (productId, variationId, currentQty, delta) => {
    const newQty = currentQty + delta;
    if (newQty <= 0) {
      dispatch(removeFromCart(productId, variationId));
    } else {
      dispatch(updateCartQuantity(productId, newQty, variationId));
    }
  };

  const subtotal = items.reduce((acc, item) => {
    const price = parseFloat(item.product?.price || 0);
    return acc + (price * item.quantity);
  }, 0);

  return (
    <Modal
      aria-labelledby='contained-modal-title-vcenter'
      centered
      show={isOpen}
      onHide={() => setIsOpen(false)}
      className='right'
    >
      <Button
        onClick={() => setIsOpen(false)}
        className='btn-close z-index-5 posa right-0 top-0 mt-3 me-3 font-xss'
      ></Button>
      <Modal.Body className='text-center pt-3 m-0 pb-3'>
        <div className='card w-100 p-2 pb-0 border-0 text-start'>
          <h4 className='fw-700 font-lg text-grey-900 text-start mb-4 mt-n2 d-block'>
            Cart
          </h4>
          
          {items.length === 0 ? (
            <p className="text-grey-500 font-xssss fw-500">Your cart is empty.</p>
          ) : (
            items.map((item, index) => {
              const product = item.product;
              const price = parseFloat(product?.price || 0).toFixed(2);
              const imgUrl = product?.cover_image || 'http://localhost:3000/static/media/img404.d8aceca746023bbb99ba.png';
              
              return (
                <div key={index} className='row mb-3 align-items-center'>
                  <div className='col-md-4 col-4'>
                    <img
                      src={imgUrl}
                      alt={product?.name}
                      className='w-100 d-inline-block bg-greylight rounded-6 object-fit-cover'
                      style={{ aspectRatio: '1/1' }}
                    />
                  </div>
                  <div className='col-md-8 col-8 ps-0'>
                    <a
                      href={`/product/${product.id}`}
                      className='text-grey-900 fw-600 font-xsss lh-22 d-block ls-0 mb-1 pe-lg-4'
                    >
                      {product?.name}
                    </a>
                    <h6 className='font-xs ls-3 fw-700 text-current float-start mt-1 mb-2 w-100'>
                      <span className='font-xsssss text-grey-500'>{currency}</span>
                      {price}{' '}
                    </h6>
                    <div className='cart-count d-flex align-items-center'>
                      <div className='number d-flex align-items-center bg-greylight rounded-6' style={{ padding: '2px 5px' }}>
                        <span className='minus cursor-pointer fw-700 px-2' onClick={() => handleUpdate(product.id, item.variationId, item.quantity, -1)}>-</span>
                        <input
                          type='text'
                          className='open-font ms-1 me-1 text-center bg-transparent border-0 text-grey-900 fw-600'
                          value={item.quantity}
                          readOnly
                          style={{ width: '30px', outline: 'none' }}
                        />
                        <span className='plus cursor-pointer fw-700 px-2' onClick={() => handleUpdate(product.id, item.variationId, item.quantity, 1)}>+</span>
                      </div>
                      <button className="btn p-0 ms-3 text-danger font-xssss" onClick={() => dispatch(removeFromCart(product.id, item.variationId))}>Remove</button>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>

        {items.length > 0 && (
          <div className='card w-100 p-3 pt-4 border-0 text-start mt-auto'>
            <div className='row'>
              <div className='col-lg-12'>
                <h4 className='text-grey-900 font-xssss fw-600 mb-2 d-flex'>
                  Subtotal <span className='ms-auto text-grey-500'>{currency} {subtotal.toFixed(2)}</span>
                </h4>
                <h4 className='text-grey-900 font-xss fw-600 mb-3 mt-3 d-flex border-top pt-3'>
                  Total <span className='ms-auto text-current'>{currency} {subtotal.toFixed(2)}</span>
                </h4>
              </div>
            </div>

            <button
              onClick={() => {
                setIsOpen(false);
                navigate('/checkout');
              }}
              className='w-100 bg-current text-white rounded-6 text-center fw-600 font-xssss btn btn-sm py-2 px-3 text-uppercase border-0 shadow-none'
            >
              Checkout
            </button>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default Index;
